export default __webpack_public_path__ + "static/media/landing.40535509.jpg";